export const searchFormOption = function () {
  return [
    // {
    //   prop: 'keyword',
    //   label: '关键字',
    //   type: 'input',
    //   placeholder: '请输入车牌号',
    //   width: '20%'
    // },
    {
      prop: 'type',
      label: '类型',
      type: 'select',
      width: '20%',
      options: [
        {
          label: '车损',
          value: 1
        },
        {
          label: '三者',
          value: 2
        }
      ]
    },
  ]
}


export default {}